import * as $dynamic from "../gleam_stdlib/gleam/dynamic.mjs";
import * as $map from "../gleam_stdlib/gleam/map.mjs";
import { CustomType as $CustomType } from "./gleam.mjs";
import { setup as application, setup_component as component, start } from "./lustre.ffi.mjs";
import * as $effect from "./lustre/effect.mjs";
import * as $element from "./lustre/element.mjs";

export { application, component, start };

export class ElementNotFound extends $CustomType {}

export class ComponentAlreadyRegistered extends $CustomType {}

export function element(element) {
  let init = () => { return [undefined, $effect.none()]; };
  let update = (_, _1) => { return [undefined, $effect.none()]; };
  let render = (_) => { return element; };
  return application(init, update, render);
}

export function simple(init, update, render) {
  let init$1 = () => { return [init(), $effect.none()]; };
  let update$1 = (model, msg) => { return [update(model, msg), $effect.none()]; };
  return application(init$1, update$1, render);
}
